import { render, staticRenderFns } from "./MyTrafficFineApprovals.vue?vue&type=template&id=fc662ae6&"
import script from "./MyTrafficFineApprovals.vue?vue&type=script&lang=js&"
export * from "./MyTrafficFineApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports